import { createContext } from 'react';

import type { PropertiesDataContextType } from './PropertiesData.interfaces';

const initState: PropertiesDataContextType = {
  data: [],
  loading: false,
};

const PropertiesDataContext =
  createContext<PropertiesDataContextType>(initState);

export default PropertiesDataContext;
